// extracted by mini-css-extract-plugin
export default {"hidden":"skJaue6pB0HgnZzyxkJc"};